/**
 * Push Notification Banner - 푸시 알림 배너
 * 화면 상단에 표시되는 알림
 */

import { motion, AnimatePresence } from 'framer-motion';
import { HiBell, HiX, HiLocationMarker } from 'react-icons/hi';
import { format } from 'date-fns';

export default function PushNotificationBanner({ notification, onClose }) {
  if (!notification) return null;

  return (
    <AnimatePresence>
      <motion.div
        className="fixed top-0 left-0 right-0 z-50 px-4 pt-4"
        initial={{ y: -100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: -100, opacity: 0 }}
        transition={{ type: "spring", stiffness: 300, damping: 30 }}
      >
        <motion.div
          className="rounded-xl shadow-2xl border-2 overflow-hidden backdrop-blur-md"
          style={{
            background: 'rgba(255, 255, 255, 0.95)',
            borderColor: 'var(--color-primary)',
          }}
          initial={{ scale: 0.95 }}
          animate={{ scale: 1 }}
          whileHover={{ scale: 1.02 }}
        >
          <div className="p-4 flex items-start gap-3">
            {/* 아이콘 */}
            <div
              className="p-2 rounded-lg flex-shrink-0"
              style={{
                background: `linear-gradient(135deg, var(--color-primary), var(--color-secondary))`,
              }}
            >
              <HiBell className="w-5 h-5 text-white" />
            </div>

            {/* 내용 */}
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 mb-1">
                <HiLocationMarker className="w-4 h-4" style={{ color: 'var(--color-primary)' }} />
                <p className="text-sm font-bold" style={{ color: 'var(--color-text)' }}>
                  스팟 존 진입 알림
                </p>
              </div>
              <p className="text-sm font-semibold mb-1" style={{ color: 'var(--color-text)' }}>
                {notification.spotName}
              </p>
              <p className="text-xs" style={{ color: 'var(--color-text-secondary)' }}>
                {notification.message}
              </p>
              <p className="text-xs mt-1 opacity-70" style={{ color: 'var(--color-text-secondary)' }}>
                {format(notification.timestamp, 'HH:mm:ss')}
              </p>
            </div>

            {/* 닫기 버튼 */}
            <motion.button
              onClick={onClose}
              className="p-1 rounded-lg hover:bg-gray-100 transition-colors flex-shrink-0"
              style={{ color: 'var(--color-text-secondary)' }}
              whileHover={{ scale: 1.1, rotate: 90 }}
              whileTap={{ scale: 0.9 }}
            >
              <HiX className="w-5 h-5" />
            </motion.button>
          </div>

          {/* 진행 바 애니메이션 */}
          <motion.div
            className="h-1"
            style={{
              background: `linear-gradient(90deg, var(--color-primary), var(--color-secondary))`,
            }}
            initial={{ width: '100%' }}
            animate={{ width: '0%' }}
            transition={{ duration: 5, ease: 'linear' }}
          />
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
}
